// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"265":"Settings","328":"admin","362":"Dashboard","723":"Manager","818":"auth"}[chunkId] + "." + {"265":"673412ba","328":"ffad8051","362":"f2908a7f","723":"aed28cc8","818":"f36a06ac"}[chunkId] + ".css";
};